"use strict";
/*
Copyright 2019 DigitalOcean

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/
Object.defineProperty(exports, "__esModule", { value: true });
const digitalOceanRegex = /.*digitalocean\.com\.*/;
const cloudflareRegex = /.*cloudflare\.com\.*/;
const namecheapRegex = /.*registrar-servers\.com.*/;
const goDaddyRegex = /.*godaddy\.com.*/;
// Defines regex checks for providers and then ways to change records with that provider.
const records = new Map();
records.set(digitalOceanRegex, "digitalocean");
records.set(cloudflareRegex, "cloudflare");
records.set(namecheapRegex, "namecheap");
records.set(goDaddyRegex, "godaddy");
exports.default = records;
